import { Skeleton } from "primereact/skeleton";
import { formatShortDate } from "sj-ui-toolkit/src/utils";

export function CertificateInfoColumn({ rowData, loading }) {
  if (loading) return <Skeleton />;

  return (
    <div className="flex flex-col">
      <span className="body-md">
        {rowData.levelName}: {rowData.name}
      </span>
      <span className="body-sm text-muted-aaa">Earned: {formatShortDate(rowData.completedAt)}</span>
    </div>
  );
}
